import * as React from 'react';
import { makeStyles } from '@fluentui/react-components';
import { HERO_CONSTANTS } from '../constants/heroConstants';
import logoImage from "../assets/logo_TS.png";

const useStyles = makeStyles({
  hero: {
    height: '50vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: '0 1rem',
    marginTop: '100px'
  },
  heroTitle: {
    fontSize: '3rem',
    color: 'var(--primary-color)',
    margin: 0,
    lineHeight: '1',
  },
  muted: {
    fontSize: '1rem',
  },
  mutedSecond: {
    marginTop: '0px'
  },
  logo: {
    height: '300px'
  }
});

const HeroSection: React.FC = () => {
  const classes = useStyles();

  return (
    <section className={classes.hero} aria-label={HERO_CONSTANTS.ARIA_LABEL}>
      <h1 className={classes.heroTitle}>
        {HERO_CONSTANTS.BRIDE_GROOM_NAMES}
      </h1>
      <p className={classes.muted}>{HERO_CONSTANTS.INVITATION_TEXT}</p>
      <img src={logoImage} alt="Logo" className={classes.logo}/>
    </section>
  );
};

export default HeroSection;